import { StatusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { ColumnHeaderUi, PagingUi } from '@/components/TableData/TableDataUi';

export type OrdersDetaillUi = {
  columnHeaders: ColumnHeaderUi[];
  items: OrderDetailItemUi[];
  paging?: PagingUi;
  isLoading?: boolean;
};

export type OrderDetailItemUi = {
  orderId: string;
  orderNumber: string;
  sellerName: string;
  buyerName: string;
  kamOwner: string;
  orderDate: string;
  badgeStatus?: StatusBadgeUi;
  remission: boolean;
  total: string;
};

const tableHeaders = [
  { label: 'ID Pedido' },
  { label: 'Vendedor' },
  { label: 'Comprador' },
  { label: 'KAM' },
  { label: 'Fecha de pedido' },
  { label: 'Estatus' },
  { label: 'Remisión' },
  { label: 'Total' },
  { label: '' },
];

export const initialState: OrdersDetaillUi = {
  columnHeaders: tableHeaders,
  items: [],
};
